export default __webpack_public_path__ + "static/media/Pagamentos.890a4a99.png";